import { components } from "@certn/api/generated-schemas/client-portal";
import {
  DropdownMenu,
  FormLabelRAC,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  userGroups: readonly components["schemas"]["UserCustomerGroupsListCustomerGroups"][];
  onRemove: (
    group: components["schemas"]["UserCustomerGroupsListCustomerGroups"]
  ) => void;
}

export function AssignedGroupsList({ userGroups, onRemove }: Props) {
  const { t } = useTranslation();

  return (
    <div className={css(styles.flexColumn, { gap: "var(--space-2)" })}>
      <FormLabelRAC isRequired>
        <Trans>Assigned groups</Trans> ({userGroups.length})
      </FormLabelRAC>
      <div className={styles.flexColumn} data-testid="user-group-list">
        {userGroups.map((group) => (
          <div
            key={group.id}
            className={styles.userGroupListItem}
            data-testid="user-group-list-item"
          >
            <div className={styles.flexColumn}>
              <Text style="global/heading-medium">{group.name}</Text>
              <Text style="global/body-secondary" color="text-weak">
                {group.user_count === 1
                  ? t("1 member")
                  : t("{{userCount}} members", {
                      userCount: group.user_count,
                    })}
              </Text>
            </div>
            <DropdownMenu
              triggerButton={
                <GhostIconButton
                  testID="group-expand-button"
                  size="small"
                  icon="more_horiz"
                  aria-label={t("Expand menu")}
                />
              }
              onItemAction={(menuItem) => {
                switch (menuItem) {
                  case "remove-group":
                    onRemove(group);
                }
              }}
            >
              <MenuSection>
                <MenuItem id="remove-group">
                  <Text
                    style="input/text-field"
                    color="text-danger"
                    testID="remove-group-button"
                  >
                    {t("Remove group")}
                  </Text>
                </MenuItem>
              </MenuSection>
            </DropdownMenu>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  userGroupListItem: css({
    display: "flex",
    justifyContent: "space-between",
    padding: "var(--space-4) 0",
    ":not(:last-child)": {
      borderBottom: "1px solid var(--border-base)",
    },
  }),
  flexColumn: css({
    display: "flex",
    flexDirection: "column",
  }),
};
